import * as React from 'react';
import * as moment from 'moment';

import { ListPerformancesProps, ListPerformancesPropsView } from '../../components/list/performance';
import { IBaseZone } from '../../../add-ons/classes/add-ons';
import { IPriceType } from '../../../add-ons/custom/classes/production';

const ListPerformanceView: React.StatelessComponent<ListPerformancesPropsView> = props => {

    function getZonePriceByQuantity(priceTypeId: number, price: number): number {
        if (props.priceTypeQuantity.has(priceTypeId))
            return props.priceTypeQuantity.get(priceTypeId) * price;
        return 0;
    }
    function getQuantity(priceTypeId: number): number {
        if (props.priceTypeQuantity.has(priceTypeId))
            return props.priceTypeQuantity.get(priceTypeId);
        return null;
    }
    function getTotalQuantity(): number {
        if (!props.performance.performancePricing)
            return 0;
        return props.performance.performancePricing.priceTypeDetails.reduce((prev, next) => { return prev + getQuantity(next.priceTypeId) }, 0);
    }
    function getZoneDescBySelectPriceType(zoneInfo: IBaseZone): string {
        var total = 0;
        zoneInfo.prices.forEach(price => {
            total += getZonePriceByQuantity(price.priceTypeId, price.price);
        });
        return `${zoneInfo.zone.description} - $${total.toFixed(2)} Total`;
    }
    function generateQuantityForPriceType(perPrice: IPriceType): number[] {                
        let dependentQuantityMax = -1;
        props.text.priceTypeQuantityDependencies.forEach(function (priceTypeQtyDependency) {
            if (priceTypeQtyDependency.dependentPriceType == perPrice.priceTypeId) {
                if (getQuantity(priceTypeQtyDependency.dependencyPriceType) > 0)
                    dependentQuantityMax = priceTypeQtyDependency.unlockedMaximumQuantity;
                else
                    dependentQuantityMax = 0;
            }
        });
        
        let quantityMax: number;
        if (dependentQuantityMax > -1) {
            quantityMax = dependentQuantityMax;
        }
        else {
            //Takes min of Tessitura price type seat quantity or Addons seat quantity
            quantityMax = Math.min(props.text.quantityMax, perPrice.maxSeats);
        }
        return Array.from(Array(quantityMax + 1).keys());
    }
    return (
        <div className="stack ace-input-list">
            <div className={props.hideDate && props.performancesCount == 1 ? "visually-hidden" : ""} >
                <input id={props.performance.id.toString()}
                    disabled={props.reserveFailed || props.performance.unavailable}
                    type="checkbox"
                    checked={props.performanceChecked}
                    key={props.performance.id}
                    value={props.performance.id}
                    onChange={(evt) => props.updatePerformance(evt)} />
                <label htmlFor={props.performance.id.toString()}>{props.performanceDetail.performanceDate}</label>
            </div>
            {props.performance.unavailable ? <div className="error-message">{props.text.performanceUnavailableMessage}</div> : null}
            {
                props.reserveFailed ?
                    props.text.seatedAddon ?
                        <div className="error-message">{props.text.seatedReserveSoldOutErrorMessage}</div>
                        : <div className="error-message">{props.text.unseatedReserveFailedErrorMessage}</div>
                    : null
            }
            {props.text.seatedAddon || !props.performanceChecked ? null :
                <div className="stack stack-border reveal-panel">
                    <div className="stack-sm">
                        <h4>Quantity</h4>
                        <ul className="ace-form">
                            {
                                props.performance.performancePricing && props.performance.performancePricing.priceTypeDetails.length > 0 ?
                                    props.performance.performancePricing.priceTypeDetails.map(perPrice => {
                                        return (
                                            <li className="ace-form-item">
                                                <label htmlFor="perfquantity">{perPrice.description}</label>
                                                <select id="perfquantity" value={getQuantity(perPrice.priceTypeId)} disabled={props.disablePriceTypeQuantity} key={perPrice.priceTypeId} name="" onChange={(evt) => props.priceTypeQuantityUpdate(props.performance.id, perPrice.priceTypeId, parseInt(evt.target.value))}>
                                                    {
                                                        generateQuantityForPriceType(perPrice).map(qty =>
                                                            <option key={qty} value={qty}>{qty}</option>
                                                        )
                                                    }
                                                </select>
                                            </li>
                                        )
                                    })
                                    :
                                    <div className="error-message">{props.text.noPriceTypeErrorMessage}</div>
                            }
                        </ul>
                    </div>
                    {
                        getTotalQuantity() > 0 &&
                        <div className="ace-form">
                            <div className="ace-form-item">
                                <h4>Section</h4>
                                {props.performanceDetail.performancePricing.zones.length > 0 ?
                                    <ul className="ace-input-list">
                                        {props.performanceDetail.performancePricing.zones.map(zoneInfo => {
                                            return (
                                                <li key={zoneInfo.zone.id}>
                                                    <input id={`zone-${props.performance.id}-${zoneInfo.zone.id}`} type="radio" value={zoneInfo.zone.id} onChange={(evt) => { props.updateZone(props.performance.id, zoneInfo.zone.id) }} name={`zones-${props.performance.id}`} />
                                                    <label htmlFor={`zone-${props.performance.id}-${zoneInfo.zone.id}`}>{getZoneDescBySelectPriceType(zoneInfo)}</label>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                    :
                                    <div className="error-message">{props.text.noZoneErrorMessage}</div>
                                }
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
    )
}

export default ListPerformanceView;